import type { EntryLocaleContent } from "../types";

/**
 * i18Next `entries:Game01.SECSA03` entry text content
 */
const SECSA03: EntryLocaleContent = {};

export default SECSA03;
